/**
 * Silences development logging in released builds.
 *
 * The app narrates itself heavily through `console.log` — including uids, email
 * addresses and Firebase payloads — which anyone can read in their browser's
 * console. Warnings and errors are left alone, since those are worth seeing.
 *
 * Call this before Sentry initialises: Sentry wraps the console to collect
 * breadcrumbs, so it records the call and then hands off to whatever it wrapped.
 * Silencing first means the breadcrumbs survive while the output stops.
 *
 * To read the logs on a deployed build (support, reproducing a report), run
 * `localStorage.setItem('svgtrace_logs', '1')` and reload.
 */
const QUIET_METHODS = ['log', 'info', 'debug', 'trace', 'dir', 'table'] as const;

export const quietConsoleInProduction = () => {
  if (process.env.NODE_ENV !== 'production') return;

  try {
    if (localStorage.getItem('svgtrace_logs') === '1') return;
  } catch (e) {
    /* storage blocked — carry on and silence */
  }

  const noop = () => {};
  QUIET_METHODS.forEach((method) => {
    if (typeof console[method] === 'function') console[method] = noop;
  });
};
